export const normalizeDomain = (domain?: string) =>
  (domain ?? "")
    .trim()
    .replace(/-admin\.(okta|oktapreview|okta-emea)\.com$/i, ".$1.com");
